export const DEFAULT_VALUES = {
  columns: [],
  data: [],
  headers: { header: "Heading" },
  id: "table"
};

export const VALIDATE_KEY_VALUES = {
  columns: true,
  data: true,
  headers: true
};
